import { render, staticRenderFns } from "./RePagination.vue?vue&type=template&id=d94870be"
import script from "./RePagination.vue?vue&type=script&lang=js"
export * from "./RePagination.vue?vue&type=script&lang=js"
import style0 from "./RePagination.vue?vue&type=style&index=0&id=d94870be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports